// extracted by mini-css-extract-plugin
export default {"circle":"ColorCircle_circle__p0ZtP"};